// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import Layout from "./components/Layout";

import Signup from "./pages/signup/Signup";

import Login from "./pages/auth/Login";
import VerifyEmail from "./pages/auth/VerifyEmail";
import Logout from "./pages/auth/Logout";
import ForgotPassword from "./pages/auth/ForgotPassword.js";
import Contact from "./pages/Contact";

import Posts from "./pages/posts/index";
import PostEdit from "./pages/posts/PostEdit";    

import Billing from "./pages/account/Billing";
import Website from "./pages/account/Website";
import Leads from "./pages/leads/Leads";
import Support from "./pages/support/Support";

function ExternalRedirect({ to }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

export default function App() {
  return (
    <Routes>
      {/* PUBLIC */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      <Route path="/login" element={<Layout><Login /></Layout>} />
      <Route path="/logout" element={<Layout><Logout /></Layout>}/>
      <Route path="/verify-email" element={<Layout><VerifyEmail /></Layout>} />
      <Route path="/forgotpassword" element={<Layout><ForgotPassword/></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      

      <Route
        path="/pricing"
        element={<ExternalRedirect to="https://bouncehouse.com/businesses#pricing" />}
      />
      <Route path="/signup" element={<Layout><Signup /></Layout>}/>


      {/* PROECTED ROUTES */}
      <Route path="/posts" element={<Navigate to="/posts/attraction" replace />}/>
      <Route path="/posts/:kind" element={ <ProtectedRoute><Layout><Posts /></Layout></ProtectedRoute>}/>
      <Route path="/posts/edit/:id" element={<ProtectedRoute><Layout><PostEdit /></Layout></ProtectedRoute>}/>

      <Route path="/billing" element={<ProtectedRoute><Layout><Billing /></Layout></ProtectedRoute>}/>
      <Route path="/website" element={<ProtectedRoute><Layout><Website /></Layout></ProtectedRoute>}/>
      <Route path="/leads" element={<ProtectedRoute><Layout><Leads /></Layout></ProtectedRoute>}/>
      <Route path="/support" element={<ProtectedRoute><Layout><Support /></Layout></ProtectedRoute>}/>

      
      
      
      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
